import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { patchInvestigation } from "../../../../../apis";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { Separator } from "../components";
import { InvolvedInfo } from "./Modals/InvolvedInfo";
import { AddInvolved } from "./AddInvolved";
import { InvolvedTypes } from "./InvolvedTypes";
import { useInvolveds } from "./hooks/useInvolveds";
import { useConstants } from "../Main/useConstants";

const initInvolveds = {
  victim: [],
  witness: [],
  offender: [],
  accomplice: [],
};

// Componente de involucrados
export const Involved = ({
  investigation,
  setInvestigation,
  justView,
  handleSelectedSection,
}) => {
  const [t] = useTranslation("investigation");
  const {
    enums,
    functions: { askUpdateInvestigationContext },
  } = useConstants();

  const [involveds, setInvolveds] = useState(initInvolveds);

  const [isAdding, setIsAdding] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedInvolved, setSelectedInvolved] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const haveInvolveds = useMemo(() => {
    return Object.values(involveds).some((involved) => involved.length > 0);
  }, [involveds]);

  useEffect(() => {
    if (investigation.involved) {
      setInvolveds(investigation.involved);
    } else {
      setInvolveds(initInvolveds);
    }
  }, [investigation.involved]);

  const handleSaveInvolveds = async (newInvolveds) => {
    const objToSave = {
      folder: {
        involved: newInvolveds,
      },
    };

    setIsLoading(true);
    try {
      await patchInvestigation(investigation.alias, objToSave);
      const updatedInvestigation = {
        ...investigation,
        involved: newInvolveds,
      };
      setInvestigation(updatedInvestigation);
      // Refresca los formatted arrays (involvedsVictimInfo, etc.) que lee la
      // sección de Entrevistas para el selector de entrevistado.
      askUpdateInvestigationContext(updatedInvestigation);
      setIsAdding(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <InvolvedInfo // MODAL
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        selectedInvolved={selectedInvolved}
        setSelectedInvolved={setSelectedInvolved}
        handleSaveInvolveds={handleSaveInvolveds}
        involvedsInInvestigation={involveds}
        isLoading={isLoading}
        justView={justView}
      />

      <Box className="dyTheme1" p={1}>
        {!isAdding && !justView && (
          <InvestigationSectionHeader
            text={t("involved.add_to_report")}
            buttonText={t("involved.add")}
            buttonIcon="outline_user_circle_add"
            onClick={() => setIsAdding(true)}
            type="involved"
          />
        )}

        {justView && (
          <Separator
            text={t("sections.involved")}
            icon="outline_profile_2_user"
            iconButton={handleSelectedSection ? "outline_edit" : undefined}
            onClick={
              handleSelectedSection
                ? () => handleSelectedSection(enums.sections.involveds)
                : undefined
            }
            sx={{ marginBottom: 1.5 }}
          />
        )}

        {!haveInvolveds && !isAdding && (
          <InvestigationAdvertisement
            title={t("involved.no_registered")}
            description={t("involved.review_and_include")}
          />
        )}

        {haveInvolveds && !isAdding && (
          <InvolvedTypes
            // involvedsInInvestigation={involvedsInInvestigation}
            involvedsInInvestigation={involveds}
            setSelectedInvolved={setSelectedInvolved}
            setShowDrawer={setShowDrawer}
            justView={justView}
          />
        )}

        {isAdding && (
          <AddInvolved
            handleSaveInvolveds={handleSaveInvolveds}
            // involvedsInInvestigation={involvedsInInvestigation}
            involvedsInInvestigation={involveds}
            setIsAdding={setIsAdding}
            isLoading={isLoading}
          />
        )}
      </Box>
    </>
  );
};
